import { motion } from 'framer-motion';

const moods = [
  { value: 1, emoji: '😢', label: 'Muy mal', color: '#EF476F' },
  { value: 2, emoji: '😕', label: 'Mal', color: '#F78C6B' },
  { value: 3, emoji: '😐', label: 'Neutral', color: '#FFD166' },
  { value: 4, emoji: '🙂', label: 'Bien', color: '#06D6A0' },
  { value: 5, emoji: '😄', label: 'Muy bien', color: '#118AB2' },
];

export const MoodSelector = ({ value, onChange }) => {
  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4" data-testid="mood-selector">
      {moods.map((mood) => (
        <motion.button
          key={mood.value}
          onClick={() => onChange(mood.value)}
          className={`relative flex flex-col items-center p-2 sm:p-3 rounded-xl transition-colors ${
            value === mood.value 
              ? 'bg-muted' 
              : 'hover:bg-muted/50'
          }`}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          data-testid={`mood-${mood.value}`}
        >
          {value === mood.value && (
            <motion.div
              layoutId="mood-indicator"
              className="absolute inset-0 rounded-xl"
              style={{ 
                border: `2px solid ${mood.color}`,
                boxShadow: `0 0 20px ${mood.color}40`
              }}
              transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            />
          )}
          <span className="text-2xl sm:text-3xl relative z-10">{mood.emoji}</span>
          <span 
            className={`text-xs mt-1 hidden sm:block ${
              value === mood.value ? 'font-semibold' : 'text-muted-foreground'
            }`}
            style={{ color: value === mood.value ? mood.color : undefined }}
          >
            {mood.label}
          </span>
        </motion.button>
      ))}
    </div>
  );
};

export const getMoodInfo = (value) => {
  return moods.find(m => m.value === value) || moods[2];
};

export default MoodSelector;
